if($('.container-padded-left, .container-padded-right').length) {

    let containerBase = $('.site-footer .container-wide');

    function setContainerPadding() {
        let offset = containerBase.offset().left;
        // if($(window).width() < 1460) offset += 35;
        if($(window).width() < 1461 && $(window).width() > 768) offset += 35;
        if($(window).width() < 768) offset += 15;
        $('.container-padded-left').css('padding-left', offset);
        $('.container-padded-right').css('padding-right', offset);
    }

    setContainerPadding();
    $(window).on('resize', function () {
        setContainerPadding();
    });

}

if($('.img-attached-left, .img-attached-right').length) {

    let containerBase = $('.site-footer .container-wide');

    function setImageOffset() {
        if($(window).width() > 991) {
            let offset = containerBase.offset().left;
            if($(window).width() < 1461 && $(window).width() > 768) offset += 35;
            if($(window).width() < 768) offset += 15;
            $('.img-attached-left').css('margin-left', 0 - offset);
            $('.img-attached-left').css('width', 'calc(100% + ' + offset + 'px)');
            $('.img-attached-right').css('margin-right', 0 - offset);
            $('.img-attached-right').css('width', 'calc(100% + ' + offset + 'px)');
        } else {
            $('.img-attached-left').css('margin-left', '');
            $('.img-attached-left').css('width', '');
            $('.img-attached-right').css('margin-right', '');
            $('.img-attached-right').css('width', '');
        }
    }

    setImageOffset();
    $(window).on('resize', function () {
        setImageOffset();
    });

}

if($('.has-img-attached-left, .has-img-attached-right').length) {

    let containerBase = $('.site-footer .container-wide');

    function setImageOffset() {
        if($(window).width() > 991) {
            let offset = containerBase.offset().left;
            if($(window).width() < 1461 && $(window).width() > 1301) offset += 35;
            if($(window).width() < 1300 && $(window).width() > 768) offset += 25;
            if($(window).width() < 768) offset += 25;
            $('.has-img-attached-left').find('img').css('margin-left', 0 - offset);
            $('.has-img-attached-left').find('img').css('width', 'calc(100% + ' + offset + 'px)');
            $('.has-img-attached-right').find('img').css('margin-right', 0 - offset);
            $('.has-img-attached-right').find('img').css('width', 'calc(100% + ' + offset + 'px)');
        } else {
            $('.has-img-attached-left').find('img').css('margin-left', '');
            $('.has-img-attached-left').find('img').css('width', '');
            $('.has-img-attached-right').find('img').css('margin-right', '');
            $('.has-img-attached-right').find('img').css('width', '');
        }
    }

    setImageOffset();
    $(window).on('resize', function () {
        setImageOffset();
    });

}
